import React from 'react';
import { Field, FastField } from 'formik';
import SwitchBoxField from 'customField/SwitchBoxField';

/**
 *
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.label
 * @param {string} props.classNameContainer
 * @param {string} props.classNameLabel
 * @param {(checked, id: string) => void} props.afterOnChange
 * @param {boolean} props.disabled
 * @param {string | JSX} props.helperText
 * @returns
 */
const Switcher = (props) => {
  const FieldWrapper = props.isFastField ? FastField : Field;
  return <FieldWrapper component={SwitchBoxField} {...props} />;
};

export default Switcher;
